<template>
    <md-card-content>
        <div>
            <span class="text-bold">Code EBP :</span>
            {{ client.code_ebp }}
        </div>
        <div class="flex items-center justify-between">
            <div>
                <span class="text-bold">Identifiant :</span>
                <span class="ml-1">{{ client.username }}</span>
            </div>
            <div class="flex items-center space-x-1.5">
				<div>
					<md-button class="md-icon-button md-raised md-info m-0" :disabled="!client.is_client_area_available"
					           @click="loginToClientArea">
						<font-awesome-icon class="md-icon" :icon="['fa', 'external-link-alt']" />
					</md-button>
					<md-tooltip md-direction="top">
						{{ client.is_client_area_available ? 'Se connecter à l\'espace client' : 'Connexion désactivé'}}
					</md-tooltip>
				</div>
				<!-- TODO: determine if this button is useful -->
				<!-- <div>
					<md-button class="md-icon-button md-raised md-info m-0">
						<i class="md-icon fas fa-reply" />
					</md-button>
					<md-tooltip md-direction="top">Renvoyer le mot de passe</md-tooltip>
				</div>-->
            </div>
        </div>
	    <div>
		    <span class="text-bold">Mot de passe :</span>
		    <span class="ml-1">{{ client.password }}</span>
	    </div>
        <div>
            <span class="text-bold">État connexion : </span>
            <span v-if="client.state === 'Activé'"
                  class="text-success">{{ client.state }}</span>
            <span v-else
                  class="text-danger">{{ client.state }}</span>
        </div>
        <div>
            <span class="text-bold">Contacts : </span>
            <template v-if="selectedContacts(client.contacts).length > 0">
                <client-contacts-selected :contacts="selectedContacts(client.contacts)"></client-contacts-selected>
            </template>
			<span v-else>Aucun</span>
        </div>
        <div>
            <span class="text-bold">Date création :</span>
            {{ client.creation }}
        </div>
        <div>
            <span class="text-bold">Date modification :</span>
            {{ client.modification }}
        </div>
        <div style="margin-top: .5rem;">
            <md-button class="md-warning button-full-width mb-0"
                       @click="goToRoute($event, 'Client Informations Edit', { id: client.id })">
                Modifier le client
            </md-button>
        </div>
    </md-card-content>
</template>

<script>
// Components
import ClientContactsSelected from "@/pages/Clients/Informations/components/ClientContactsSelected";

// Mixins
import routerMixin from "../../../mixins/router-mixin";
export default {
    name: "Informations",
    components: {
        ClientContactsSelected
    },
	mixins: [routerMixin],
    props: {
        client: Object
    },
    methods: {
        selectedContacts(contacts = []) {
            return contacts.filter(contact => contact.is_selected)
        },
        contactFullName(contact) {
            return contact.last_name + ' ' + contact.first_name
        },
	    async loginToClientArea() {
		    const user = {
				data: {
					type: 'token',
					attributes: {
						username: this.client.username,
						password: this.client.password
					}
				}
		    }

		    const requestOptions = {
			    headers: {
				    Accept: "application/vnd.api+json",
				    "Content-Type": "application/vnd.api+json",
			    },
		    }

		    try {
				const { data } = await this.$store.dispatch('caLogin', { user, requestOptions })
			    const clientArea = {
				    accessToken: data.accessToken,
				    userType: data.userType
			    }
			    localStorage.setItem("client-area", JSON.stringify(clientArea))
			    let newRoute = this.$router.resolve({ name: 'caDashboard' })
			    window.open(newRoute.href, '_blank')
		    } catch (e) {}
	    }
    }
}
</script>

<style scoped lang="scss">
::v-deep {
    .md-card-actions {
        margin: 0 20px 10px;
        button {
            margin: 0 5px 5px 0 !important;
        }
        button:last-child {
            margin-right: 0 !important;
        }
    }
    .md-icon-button {
        margin: 0;
        padding: 5px;
        height: 27px;
        min-width: 35px;
        width: auto;
        line-height: 27px;
        .md-icon {
            font-size: 0.875rem !important;
            min-width: 0.875rem !important;
            height: 0.875rem !important;
        }
    }
}

.text-bold {
    font-weight: 500;
}

.button-full-width {
    width: 100%;
}
</style>
